// 各頁面原本硬編中文抽出的詞條（CB7REQ-170）；key 為語言中性，四語系同步維護
export default {
  "pageText.activity.memberAccountOrPhone": "Cuenta de Miembro / Teléfono",
  "pageText.activity.freeCheckinPoints": "Puntos Emitidos por Registro Gratuito",
  "pageText.activity.depositCheckinPoints": "Puntos Emitidos por Registro con Depósito",
  "pageText.activity.unit": "Unidad",
  "pageText.activity.issueQty": "Cantidad a Emitir",
  "pageText.activity.treasureIssuePHP": "Cofre Emitido (PHP)",
  "pageText.activity.treasureIssueUSDT": "Cofre Emitido (USDT)",
  "pageText.activity.treasureIssueVND": "Cofre Emitido (VND)",
  "pageText.activity.treasureClaimPHP": "Cofre Reclamado (PHP)",
  "pageText.activity.treasureClaimUSDT": "Cofre Reclamado (USDT)",
  "pageText.activity.treasureClaimVND": "Cofre Reclamado (VND)",
  "pageText.activity.treasureExpirePHP": "Cofre Expirado (PHP)",
  "pageText.activity.treasureExpireUSDT": "Cofre Expirado (USDT)",
  "pageText.activity.treasureExpireVND": "Cofre Expirado (VND)",
  "pageText.activity.qtyMustBePositive": "La cantidad debe ser mayor que 0",
  "pageText.activity.maxValue": "Máximo",
  "pageText.activity.minValue": "Mínimo",
  "pageText.activity.maxAmountGteMin": "El monto máximo debe ser >= al mínimo",
  "pageText.activity.idRequired": "ID no ingresado",
  "pageText.activity.actPkRequired": "Se requiere la clave primaria de la actividad; cargue primero la configuración",
  "pageText.activity.filter": "Filtrar",
  "pageText.activity.queryUserStatusFirst": "Consulte primero el estado del usuario",
  "pageText.activity.bonusRangesRequired100": "Configure todos los rangos de bono con probabilidad total del 100%",
  "pageText.activity.uploadAtLeastOneImage": "Suba al menos una imagen",
  "pageText.activity.addAtLeastOneBonusRange": "Agregue al menos un rango de bono",
  "pageText.activity.enterIssueQty": "Ingrese la cantidad a emitir",
  "pageText.activity.selectItemType": "Seleccione el tipo de ítem",
  "pageText.activity.accountsSemicolonHint": "(separe varias cuentas con ;)",
  "pageText.activity.fileMax50MB": "¡El archivo no puede superar 50MB!",
  "pageText.financial.failCountLimit5Min": "Límite de fallos en 5 min",
  "pageText.financial.eg10": "ej. 10",
  "pageText.financial.eg10000": "ej. 10000.00",
  "pageText.financial.eg500": "ej. 500.00",
  "pageText.financial.singlePayLimit": "Límite por pago",
  "pageText.financial.paramSetFailed": "Error al guardar los parámetros",
  "pageText.financial.paramSetSuccess": "Parámetros guardados",
  "pageText.financial.paramConfigFailed": "Error al configurar los parámetros",
  "pageText.financial.paramConfigSuccess": "Parámetros configurados",
  "pageText.financial.teamsGroupHint": "Ingrese el nombre del grupo de Teams o la URL del webhook",
  "pageText.financial.rejectFailed": "Error al rechazar",
  "pageText.financial.payTypeCode": "Código de Tipo de Pago",
  "pageText.financial.payTypeName": "Nombre del Tipo de Pago",
  "pageText.financial.channelNotFound": "Canal no encontrado",
  "pageText.financial.payingInProgress": "Pago en curso",
  "pageText.financial.dailyPayLimit": "Límite diario de pago",
  "pageText.financial.confirmDeletePayType": "¿Eliminar este tipo de pago?",
  "pageText.financial.confirmRechargeFailed": "Error al confirmar el depósito",
  "pageText.financial.confirmRechargeSuccess": "Depósito confirmado",
  "pageText.financial.autoPayoutSwitch": "Interruptor de pago automático",
  "pageText.financial.autoPayoutSort": "Orden de pago automático",
  "pageText.financial.getPayChannelListFailed": "Error al cargar los canales de pago",
  "pageText.financial.getPayChannelDataFailed": "Error al cargar los datos del canal de pago",
  "pageText.financial.getParamSetFailed": "Error al cargar los parámetros",
  "pageText.financial.getPayTypeDataFailed": "Error al cargar los tipos de pago",
  "pageText.financial.getCurrencyListFailed": "Error al cargar las monedas",
  "pageText.financial.unlockFailed": "Error al desbloquear",
  "pageText.financial.unlockSuccess": "Desbloqueado",
  "pageText.financial.enterPayTypeCode": "Ingrese el código del tipo de pago",
  "pageText.financial.enterPayTypeName": "Ingrese el nombre del tipo de pago",
  "pageText.financial.enterAmountMax2Decimals": "Ingrese un monto con máximo 2 decimales",
  "pageText.financial.notifyGroup": "Grupo de notificación",
  "pageText.financial.lockFailed": "Error al bloquear",
  "pageText.financial.lockSuccess": "Bloqueado",
  "pageText.luckySpin.effectImmediately": "✓ Efectivo de inmediato",
  "pageText.luckySpin.validSameDayOnly": "Válido solo el mismo día",
  "pageText.luckySpin.validSameDayOnlyDetail": "Válido solo el mismo día; expira a las 00:00 del día siguiente",
  "pageText.luckySpin.withinValid": "válido dentro de",
  "pageText.luckySpin.multiLangConfigExternal": "Configuración multilingüe (visualización externa)",
  "pageText.luckySpin.daysHoursNotBothZero": "Los días y las horas no pueden ser 0 a la vez",
  "pageText.luckySpin.hourRange": "Rango de horas: 0-23",
  "pageText.luckySpin.hourUnit": "h",
  "pageText.luckySpin.effectNextDayMidnight": "Efectivo a las 00:00 del día siguiente",
  "pageText.luckySpin.selectAfterClaimMode": "Seleccione el modo posterior al reclamo",
  "pageText.luckySpin.afterClaim": "Después del reclamo",
  "pageText.luckySpin.afterClaimMode": "Modo posterior al reclamo",
  "pageText.member.anchor": "Streamer",
  "pageText.member.tradeRangeMax7Days": "El rango de tiempo no puede superar 7 días",
  "pageText.member.lastOnlineTime": "Última conexión: ",
  "pageText.member.lastDepositTime": "Último depósito: ",
  "pageText.member.registerTime": "Registrado: ",
  "pageText.member.loginDomain": "Dominio de acceso: ",
  "pageText.member.getWalletAccountsFailed": "Error al cargar las cuentas de billetera",
  "pageText.member.getBankCardsFailed": "Error al cargar las tarjetas bancarias",
  "pageText.member.requestFailed": "Solicitud fallida",
  "pageText.member.resetWithdrawPwdError": "Error al restablecer la contraseña de retiro",
  "pageText.member.resetLoginPwdError": "Error al restablecer la contraseña de acceso",
  "pageText.member.firstDepositTime": "Primer depósito: ",
  "pageText.sys.createRole": "Crear Rol",
  "pageText.sys.failed": "Fallido",
  "pageText.sys.opFailedRetry": "Operación fallida, inténtelo de nuevo",
  "pageText.sys.dataLoadFailed": "Error al cargar los datos",
  "pageText.sys.memberAccount": "Cuenta de Miembro",
  "pageText.sys.messageContent": "Contenido del Mensaje",
  "pageText.sys.updateFailed": "Error al actualizar",
  "pageText.sys.addFailed": "Error al agregar",
  "pageText.seo.featureInDevelopment": "Función en desarrollo...",
  "pageText.seo.monthlyImpressions": "Impresiones Mensuales",
  "pageText.seo.monthlyImpressionsGsc": "Impresiones Mensuales (GSC)",
  "pageText.sms.enterSenderId": "Ingrese el Sender ID",
  "pageText.sms.countryUS": "US - Estados Unidos",
  "pageText.risk.supKycPkMissing": "Falta supDataPkCode (clave del KYC complementario); no se puede enviar a revisión",
  "pageText.risk.supKycNotFound": "No existe el registro KYC complementario",
  "pageText.risk.supKycMemberMissing": "Falta el ID de miembro en el registro KYC complementario",
  "pageText.risk.formValidateFailed": "Validación fallida; revise los campos obligatorios",
  "pageText.inbox.startDateTime": "Fecha y hora de inicio",
  "pageText.inbox.endDateTime": "Fecha y hora de fin",
  "pageText.common.loading": "Cargando...",
  "pageText.common.noData": "Sin datos",
  "pageText.common.unknown": "Desconocido",
  "pageText.common.filter": "Filtrar",
  "pageText.common.allAgents": "Todos los agentes",
  "pageText.activity.eggReady": "Listo para incubar",
  "pageText.activity.hatchedNoEnergy": "Incubado (sin energía)",
  "pageText.activity.eg24000": "ej. 24000",
  "pageText.activity.onlyTopTier": "Solo el nivel más alto puede rellenarse",
  "pageText.financial.editPayType": "Editar Tipo de Pago",
  "pageText.financial.addPayType": "Agregar Tipo de Pago",
  "pageText.financial.getDataFailed": "Error al cargar los datos",
  "pageText.financial.changePayChannelFailed": "Error al cambiar el canal de pago",
  "pageText.risk.rejectFailed": "Error al rechazar",
  "pageText.member.streamerUser": "Usuario streamer",
  "pageText.member.patrolUser": "Usuario de patrulla",
  "pageText.member.normalUser": "Usuario normal",
  "pageText.member.gameCategory3DHall": "Sala 3D",
  "pageText.common.autoLogout": "Cierre de Sesión Automático",
  "pageText.common.stay": "Quedarme",
  "pageText.common.leave": "Salir",
  "pageText.common.autoLogoutReason": "Para evitar acciones maliciosas mientras está lejos de su computadora",
  "pageText.common.autoLogoutStayHint": "Para seguir conectado, pulse \"Quedarme\"",
  "pageText.common.scrollToTop": "Desplazar al inicio",
  "pageText.common.scrollToBottom": "Desplazar al final",
  "pageText.common.uploadTimeout": "Tiempo de subida agotado",
  "pageText.common.imageUploadFailed": "Error al subir la imagen",
  "pageText.common.uploadingImage": "Subiendo la imagen...",
  "pageText.common.enterContent": "Ingrese el contenido...",
  "pageText.common.selectAll": "Seleccionar todo",
  "pageText.common.selectVipLevel": "Seleccione el nivel VIP",
  "pageText.common.uploadSuccess": "Subida exitosa",
  "pageText.common.uploadFailed": "Error al subir",
  "pageText.common.metaDescPreview": "La meta descripción aparecerá aquí…"
};
